import React from "react";

const TableRowsLoader = ({ cardCount = 3 }) => {
  return (
    <div className="item_loader">
      <div className="item_loader_header fade-in" />
      <div className="item_loader_fitler fade-in" />

      <div className="table_loader_body">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={index} className="table_loader_body_rows fade-in" />
        ))}
      </div>
    </div>
  );
};

export default TableRowsLoader;